import { en } from './local';
import TimeAgo from 'javascript-time-ago';

TimeAgo.addDefaultLocale(en);
